import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { routes } from '../../../../routes';
import magic from '../../../../util/magic';
import { isNilOrEmpty } from '../../../../util/redux';

import Card from '../../../../components/Card';
import StatusBoxes from '../../../../components/StatusBoxes';
import { getRegistrationExpirationInfo } from '../../../../util/helpers';

const propTypes = {
  registration: PropTypes.object,
  extensions: PropTypes.array,
};

const RegistrationCard = ({ registration, extensions }) => {
  getRegistrationExpirationInfo(registration, extensions);
  const isTraining = !isNilOrEmpty(registration.trainingId);

  return (
    <Card training className="mb-4">
      <Card.Header registration>
        <div>{isTraining ? registration.training.name : registration.certification.name} Registration</div>
        <div className="subheader">
          <span className="font-weight-bold">Status: </span>
          {registration.expirationStatus == magic.expired ||
          registration.expirationStatus == magic.expiredWithoutExtension
            ? 'Expired'
            : registration.status}
        </div>
      </Card.Header>
      <Card.Body>
        {registration.step != magic.complete && !isTraining && (
          <Fragment>
            <p className="font-weight-bold">Course Progress:</p>
            <StatusBoxes certificationId={registration.certificationId} step={registration.step} />
          </Fragment>
        )}
        {registration.expirationStatus == magic.expiredWithoutExtension ? (
          <Link
            to={routes.certificationsAndTraining.extension.request}
            className="btn btn-outline-info btn-sm float-right"
          >
            Request Extension
          </Link>
        ) : registration.expirationStatus == magic.expired ? (
          <Link to={routes.certificationsAndTraining.register.root} className="btn btn-outline-info btn-sm float-right">
            Re-Enroll
          </Link>
        ) : (
          <Link
            to={
              isTraining
                ? routes.certificationsAndTraining.register.trainingBuilder(registration.trainingId)
                : routes.certificationsAndTraining.register.typeBuilder(registration.certificationId)
            }
            className="btn btn-outline-info btn-sm float-right"
          >
            View Registration
          </Link>
        )}
      </Card.Body>
    </Card>
  );
};

RegistrationCard.propTypes = propTypes;

export default RegistrationCard;
